import { render, staticRenderFns } from "./montage.vue?vue&type=template&id=8864c3ea&"
import script from "./montage.vue?vue&type=script&lang=js&"
export * from "./montage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports